import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { string, bool } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** The number that identifies an article/cabinet/in store bin */
  value: string,
  /** Label which gives more context about component in some places */
  label: string,
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Can be used to add classes to base HTML element. */
  className: string,
  /** Boolean which changes the background-color and color of value */
  subtle: bool
};
const ProductIdentifier = (props) => {
  const {
    value = "123.456.78",
    className,
    prefix = "",
    label,
    subtle,
    ...other
  } = props;
  const classes = cx(
    `${prefix}product-identifier`,
    className,
    subtle && `${prefix}product-identifier--subtle`
  );
  return /* @__PURE__ */ jsxs("span", { "x-ms-format-detection": "none", className: classes, ...other, children: [
    label && /* @__PURE__ */ jsx("span", { className: `${prefix}product-identifier__label`, children: label }),
    /* @__PURE__ */ jsx("span", { className: `${prefix}product-identifier__value`, children: value })
  ] });
};
ProductIdentifier.propTypes = propTypes;
var ProductIdentifier_default = ProductIdentifier;
export {
  ProductIdentifier_default as default
};
